import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import MenuItemsCarouselRenderer from '@peracto/peracto-blocks-tailwind/dist/content/MenuItemsCarousel/Renderer/MenuItemsCarouselRenderer'

const MenuItemsCarouselForm = lazyLoad(() => import('./Form/MenuItemsCarouselForm'))

const menuItemsCarouselPlugin = settings =>
    createPlugin({
        Renderer: MenuItemsCarouselRenderer,
        Controls: MenuItemsCarouselForm,
        ...settings,
    })

const menuItemsCarousel = menuItemsCarouselPlugin()
export default menuItemsCarousel

export { menuItemsCarouselPlugin, MenuItemsCarouselRenderer }
